import React, { useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { getWsBaseUrl } from '../../utils/env';

interface PortingStatusProps {
  portingRequestId: string;
  organizationId: string;
}

interface PortingHistoryItem {
  timestamp: string;
  status: string;
  note: string;
}

const PortingStatus: React.FC<PortingStatusProps> = ({ portingRequestId, organizationId }) => {
  const [status, setStatus] = useState('Loading...');
  const [history, setHistory] = useState<PortingHistoryItem[]>([]);

  useEffect(() => {
    const socket = io(getWsBaseUrl());

    socket.on(`porting:update:${organizationId}`, (data) => {
      if (data.id === portingRequestId) {
        setStatus(data.status);
        setHistory(data.statusHistory);
      }
    });

    // Fetch initial state
    // In a real app, you would fetch the current state via an API call
    
    return () => {
      socket.disconnect();
    };
  }, [portingRequestId, organizationId]);

  return (
    <div>
      <h2>Porting Status</h2>
      <p>Current Status: <strong>{status}</strong></p>
      <ul>
        {history.map((item, index) => (
          <li key={index}>
            {item.timestamp}: {item.status} - {item.note}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PortingStatus;
